// Configuration file
// Update these values based on your deployment

const CONFIG = {
  // For Apps Script backend:
  // BACKEND_URL: 'https://script.google.com/macros/s/YOUR_SCRIPT_ID/exec',
  
  // For Node.js backend:
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL || 'https://read.hamlin.org/api',
  
  // Google OAuth Client ID
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || '1055149718490-a854ts3lhuadoduorejqno0kdje7s4k4.apps.googleusercontent.com',
  
  // Backend type: 'apps-script' or 'nodejs'
  BACKEND_TYPE: process.env.REACT_APP_BACKEND_TYPE || 'nodejs',
};

export default CONFIG;

